import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsWillContestsProbateAndEstateLitigationInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/will-contests-probate-and-estate-litigation-in-new-york/']} />;
}
